import React, { useState } from "react";
import styled from "styled-components";
import { Tooltip } from "react-tooltip";
import { Link } from "gatsby";

import LogoCobj from "../../images/cobj.gif";
import LogoPBJ from "../../images/pbj.gif";
import LogoVOBJ from "../../images/vobj.gif";
import LogoKBJ from "../../images/logo-kbj.svg";

import Facebook from "../../images/facebook.svg";
import Twitter from "../../images/x-logo.svg";
import Instagram from "../../images/instagram.svg";
import Youtube from "../../images/youtube.svg";
import Linkedin from "../../images/linkedin.svg";

import FacebookPink from "../../images/facebook_pink.svg";
import TwitterPink from "../../images/twitter_pink.svg";
import InstagramPink from "../../images/instagram_pink.svg";
import YoutubePink from "../../images/youtube_pink.svg";
import LinkedinPink from "../../images/linkedin_pink.svg";

const Container = styled.footer`
  max-width: ${(props) => (props.fullwidth ? "100vw" : "calc(1400px - 4rem)")};
  margin-left: auto;
  margin-right: auto;
  display: flex;
  min-height: 130px;
  justify-content: space-around;
  align-items: center;
  border-top: 1px solid #ebeaea;
  column-gap: 17px;
  @media (max-width: 880px) {
    flex-direction: column;
    padding-top: 2rem;
    padding-bottom: 1rem;
    max-width: calc(100vw - 1rem);
    min-height: 260px;
  }
  a {
    font-family: Catamaran, sans-serif;
    color: #000;
  }
  a.pbj {
    text-decoration: none;
  }
  a span {
    font-weight: bold;
    font-family: Catamaran, sans-serif;
    color: var(--pink);
  }
`;

const Text = styled.div`
  font-family: Catamaran, sans-serif;
  font-size: 14px;
  color: #000;
  padding-left: 1rem;
  padding-right: 1rem;
  a {
    white-space: nowrap;
  }
  @media (max-width: 1090px) {
    br {
      display: none;
    }
  }
  @media (max-width: 880px) {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    max-width: calc(100vw - 1rem);
  }
  @media (max-width: 400px) {
    padding-bottom: 2rem;
  }
`;

const Companies = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  column-gap: 17px;
  min-width: 20%;
  @media (max-width: 880px) {
    padding-top: 1rem;
  }
  img {
    width: 100%;
    height: auto;
    max-width: 49px;
    max-height: 49px;
    object-fit: cover;
  }
`;

const Socials = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  min-width: 20%;
  column-gap: 18px;
  @media (max-width: 880px) {
    padding-top: 2rem;
  }
  img.linkedin {
    width: 29px;
    height: 29px;
  }
  img.instagram {
    width: 30px;
    height: 30px;
  }
  img.twitter {
    width: 26px;
    height: 21px;
  }
`;

const Footer = ({ fullwidth }) => {
  const year = new Date().getFullYear();

  const [tw, setTw] = useState(Twitter);
  const [li, setLi] = useState(Linkedin);
  const [ins, setIns] = useState(Instagram);

  return (
    <div className="no-print">
      <Tooltip
        id="footer-tooltip"
        style={{
          boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          opacity: "0.99",
          border: "1px solid #000",
          color: "#333",
          padding: "1.5rem",
          zIndex: "10",
          maxWidth: "300px",
          backgroundColor: "#ffc200",
          fontFamily: "Catamaran, sans-serif",
        }}
      />
      <Container fullwidth={fullwidth}>
        <Text>
          <Link className="pbj" to="/">
            <span>COBJ</span>
          </Link>
          . KBJ & PBJ Corporate Division. Copyright &copy; 2015-{year} COBJ
          Management
          <br /> <a href="/privacy-policy.pdf">Privacy Policy</a> |{" "}
          <Link to="/cookie-policy">Cookie Policy</Link> All images and text on
          this site are strictly under copyright.
          <br />
          &nbsp;No unauthorsed reproduction. <Link to="/terms">View terms</Link>
          .
        </Text>
        <Companies>
          <Link to="/">
            <img
              src="data:image/gif;base64,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"
              alt="COBJ"
            />
          </Link>

          <a
            href="https://www.kbjmanagement.co.uk/"
            data-tooltip-id="footer-tooltip"
            data-tooltip-content="Representing talent for broadcast, brand & digital, literary & live."
            data-tooltip-place="top"
          >
            <img src={LogoKBJ} alt="KBJ" />
          </a>

          <a
            href="http://pbjmanagement.co.uk/"
            data-tooltip-id="footer-tooltip"
            data-tooltip-content="Representing the cream of UK comedic, acting and presenting talent."
            data-tooltip-place="top"
          >
            <img src={LogoPBJ} alt="PBJ" />
          </a>

          <a
            href="https://www.vobjmanagement.co.uk/"
            data-tooltip-id="footer-tooltip"
            data-tooltip-content="VOBJ is the voice-over arm of PBJ Management and handles all voice-over enquiries for PBJ and KBJ clients."
            data-tooltip-place="top"
          >
            <img src={LogoVOBJ} alt="VOBJ" />
          </a>
        </Companies>
        <Socials>
          <a
            href="https://www.linkedin.com/company/cobj-management/"
            target="_blank"
          >
            <img
              onMouseLeave={(e) => setLi(Linkedin)}
              onMouseEnter={(e) => setLi(LinkedinPink)}
              className="linkedin"
              src={li}
              alt="LinkedIn"
            />
          </a>
          <a href="https://www.instagram.com/cobjmanagement/" target="_blank">
            <img
              onMouseLeave={(e) => setIns(Instagram)}
              onMouseEnter={(e) => setIns(InstagramPink)}
              className="instagram"
              src={ins}
              alt="Instagram"
            />
          </a>
          <a href="https://x.com/cobjmanagement" target="_blank">
            <img
              onMouseLeave={(e) => setTw(Twitter)}
              onMouseEnter={(e) => setTw(TwitterPink)}
              className="twitter"
              src={tw}
              alt="X"
            />
          </a>
        </Socials>
      </Container>
    </div>
  );
};

export default Footer;
